__webpack_require__.p = "/wp-content/plugins/educator_workspace/dist/";